/* eslint-disable react/jsx-wrap-multilines */
import React from 'react';
import './styles.less';
import PropTypes from 'prop-types';
import { Popup } from 'semantic-ui-react';
import WeightIcon from '../../../../components/icons/weight-icon.svg';
import CountIcon from '../../../../components/icons/count-icon.svg';
import SizeIcon from '../../../../components/icons/size-icon.svg';
import { KgIcon, VolumeIcon, PieceIcon } from '../../../../components/text-icon';

const OrdersCustomModalCell = ({ rowData }) => {
	if (rowData.id === 'customer') {
		return (
			<span className="orders-custom-modal-cell__cell">
				<div className="orders-custom-modal-cell__cell_bold">{rowData.value.name}</div>
				<div className="orders-custom-modal-cell__cell_thin">{rowData.value.code}</div>
			</span>
		);
	}

	if (['address_from', 'address_to'].includes(rowData.id)) {
		return (
			<div className="orders-custom-modal-cell__address">
				<div className="orders-custom-modal-cell__address-block">
					<div className="orders-custom-modal-cell__address-name">{rowData.value.name}</div>
					<div className="orders-custom-modal-cell__address-address">{rowData.value.inn}</div>
					<div className="orders-custom-modal-cell__address-address">{rowData.value.address}</div>
				</div>
				<div className="orders-custom-modal-cell__address-block">
					<div className="orders-custom-modal-cell__address-block-item">
						<span className="orders-custom-modal-cell__address-label">Режим работы:</span>{' '}
						{rowData.value.time}
					</div>
					<div className="orders-custom-modal-cell__address-block-item">
						{rowData.id === 'address_to' && (
							<>
								<span className="orders-custom-modal-cell__address-label">Доставить до:</span>{' '}
								{rowData.value.cargo_date}
							</>
						)}
					</div>
				</div>
			</div>
		);
	}

	if (['mode', 'cost', 'number'].includes(rowData.id)) {
		return <span className="orders-custom-modal-cell">{rowData.value}</span>;
	}

	if (rowData.id === 'cargo') {
		return (
			<div className="orders-custom-modal-cell__cargo">
				{rowData.value.weight && (
					<Popup
						content={
							<p>
								<b>Масса:</b> {`${rowData.value.weight} кг`}{' '}
							</p>
						}
						trigger={
							<div className="orders-custom-modal-cell__cargo-item">
								<img
									className="orders-custom-modal-cell__cargo-image"
									src={WeightIcon}
									alt="weight-icon"
								/>
								<div className="orders-custom-modal-cell__cargo-field">{rowData.value.weight}</div>
								{KgIcon}
							</div>
						}
						position="top center"
						size="mini"
						inverted
						style={{ textAlign: 'center', fontSize: 12, fontWeight: '500' }}
					/>
				)}
				{rowData.value.volume && (
					<Popup
						content={
							<p>
								<b>Объем:</b> {`${rowData.value.volume} м³`}
							</p>
						}
						trigger={
							<div className="orders-custom-modal-cell__cargo-item">
								<img
									className="orders-custom-modal-cell__cargo-image"
									src={SizeIcon}
									alt="weight-icon"
								/>
								<div className="orders-custom-modal-cell__cargo-field">{rowData.value.volume}</div>
								{VolumeIcon}
							</div>
						}
						position="top center"
						size="mini"
						inverted
						style={{ textAlign: 'center', fontSize: 12, fontWeight: '500' }}
					/>
				)}
				{rowData.value.place && (
					<Popup
						content={
							<p>
								<b>Места:</b> {`${rowData.value.place} шт`}
							</p>
						}
						trigger={
							<div className="orders-custom-modal-cell__cargo-item">
								<img
									className="orders-custom-modal-cell__cargo-image"
									src={CountIcon}
									alt="weight-icon"
								/>
								<div className="orders-custom-modal-cell__cargo-field">{rowData.value.place}</div>
								{PieceIcon}
							</div>
						}
						position="top center"
						size="mini"
						inverted
						style={{ textAlign: 'center', fontSize: 12, fontWeight: '500' }}
					/>
				)}
			</div>
		);
	}

	return rowData.value || '---';
};

OrdersCustomModalCell.propTypes = {
	rowData: PropTypes.object.isRequired,
	columnId: PropTypes.string.isRequired,
};

export { OrdersCustomModalCell };
